"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _styles = require("@mui/material/styles");
var _default = exports.default = function _default(theme) {
  return {
    root: {
      position: 'relative',
      display: 'inline-block',
      width: '100%',
      maxWidth: 500
    },
    rootMobile: (0, _objectSpread2.default)({}, theme.typography.body2, {
      backgroundColor: theme.palette.background2,
      borderBottom: '1px solid #E0E0E0',
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none',
      height: 40,
      paddingLeft: 8,
      paddingTop: 10,
      position: 'absolute',
      marginTop: -40,
      opacity: 0
    }),
    mobileRangeRoot: {
      minWidth: '100%'
    },
    fromInput: {
      position: 'relative',
      display: 'inline-block',
      width: 'calc(50% - 4px)',
      marginRight: theme.spacing(1)
    },
    toInput: {
      position: 'relative',
      display: 'inline-block',
      width: 'calc(50% - 4px)',
      marginLeft: 4
    },
    absolute: {
      position: 'absolute'
    },
    right4: {
      right: 4
    },
    dayPickerMargin: {
      top: -337,
      width: 'calc(100% - 4px)'
    },
    rangePickerContainer: {
      display: 'flex',
      alignItems: 'flex-start'
    },
    // The container element
    container: {
      width: '100%',
      display: 'inline-block',
      fontFamily: theme.typography.fontFamily
    },
    // The wrapper element, used for keyboard interaction
    wrapper: {
      width: '100%',
      position: 'relative',
      userSelect: 'none',
      flexDirection: 'row',
      backgroundColor: theme.palette.background3
    },
    // TODO : Added to the container when there's no interaction with the calendar
    interactionDisabled: {},
    // The navigation bar with the arrows to switch between months
    navBar: {},
    // Button to switch to the previous month
    navButtonPrev: {},
    // Button to switch to the next month
    navButtonNext: {},
    // Added to the navbuttons when disabled with fromMonth/toMonth props
    navButtonInteractionDisabled: {
      display: 'none'
    },
    // Container of the months table
    months: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      padding: '0 14px'
    },
    // The month's main table
    month: {
      display: 'table',
      borderSpacing: 0,
      userSelect: 'none'
      // margin: '0 1rem',
      // marginTop: '1rem',
    },
    // The caption element, containing the current month's name and year
    caption: {
      padding: '0 0.5rem',
      display: 'table-caption',
      textAlign: 'left',
      marginBottom: '0.5rem',
      '&div': {
        fontSize: '1.15rem',
        fontWeight: 500
      }
    },
    // Table header displaying the weekdays names
    weekdays: {
      marginTop: '1rem',
      display: 'table-header-group'
    },
    // Table row displaying the weekdays names
    weekdaysRow: {
      display: 'table-row',
      height: 40
    },
    // Cell displaying the weekday name
    weekday: (0, _objectSpread2.default)({
      display: 'table-cell'
    }, theme.typography.body2, {
      color: theme.palette.neutral.main,
      textAlign: 'center',
      verticalAlign: 'middle'
    }),
    // Table's body with the weeks
    body: {
      display: 'table-row-group',
      padding: '12px 0'
    },
    week: {
      display: 'table-row'
    },
    // Table's row for each week
    weekNumber: {
      display: 'table-cell',
      padding: '0.5rem',
      textAlign: 'right',
      verticalAlign: 'middle',
      minWidth: '1rem',
      fontSize: '0.75em',
      cursor: 'pointer',
      color: '#8b9898',
      borderRight: '1px solid #eaecec'
    },
    // The single day cell
    day: (0, _objectSpread2.default)({
      display: 'table-cell',
      padding: '4px 8px',
      textAlign: 'center',
      cursor: 'pointer',
      verticalAlign: 'middle',
      outline: 'none'
    }, theme.typography.body2, {
      color: theme.palette.neutral.dark
    }),
    // The calendar footer (only with todayButton prop)
    footer: {
      marginTop: 12,
      borderTop: '1px solid',
      borderTopColor: theme.palette.divider,
      padding: '5px',
      width: '100%'
    },
    // The today button (only with todayButton prop)
    todayButton: (0, _objectSpread2.default)({
      display: 'table',
      minWidth: 230,
      margin: '0 auto',
      border: 'none',
      backgroundImage: 'none',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      cursor: 'pointer',
      height: 30
    }, theme.typography.body2, {
      color: theme.palette.neutral.main,
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: (0, _styles.alpha)(theme.palette.neutral.dark, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      borderRadius: 4
    }),
    /* default modifiers */
    // Added to the day's cell for the current day
    today: {
      // color: theme.palette.primary.light,
      // position: 'relative',
      // borderRadius: '50%',
      // color: `${theme.palette.neutral.dark} !important`,
      // fontWeight: theme.typography.fontWeightMedium,
      // '&:before': {
      //     content: '""',
      //     position: 'absolute',
      //     top: 0,
      //     left: 0,
      //     display: 'inline-block',
      //     width: '100%',
      //     height: '100%',
      //     borderRadius: '50%',
      //     boxShadow: `inset 0 0 0 2px ${theme.palette.neutral.main}`,
      // },
    },
    // Added to the day's cell outside the current month
    outside: {
      backgroundColor: '#F8F9FB',
      color: theme.palette.neutral.main,
      cursor: 'default'
    },
    // Added to the day's cell specified in the "disabledDays" prop
    disabled: {
      color: '#dce0e0',
      cursor: 'default'
    },
    // Added to the day's cell specified in the "selectedDays" prop
    /*
    selected: {
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.business.primary.contrastText,
    },
    */
    selected: {
      // backgroundColor: alpha(theme.palette.business.primary.normal, 0.36),
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: '0%',
      border: 'none'
    },
    currentDay: {
      position: 'relative',
      color: "".concat(theme.palette.neutral.dark, " !important"),
      fontWeight: theme.typography.fontWeightMedium,
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'inline-block',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.neutral.main)
      }
    }
  };
};